import React from 'react';

/**
 * Simple loading screen with OMNILAW branding only
 * No organization data - just clean app branding
 */
const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-background via-background to-muted/20 flex items-center justify-center z-50">
      <div className="flex flex-col items-center gap-8">
        {/* OMNILAW Logo */}
        <div className="relative">
          <div className="absolute inset-0 bg-gold/10 blur-3xl rounded-full animate-pulse" />
          <div className="relative">
            <img
              src="/OmniLawLogoTransparentHorizontal.png"
              alt="OmniLaw"
              className="h-20 w-auto object-contain"
            />
          </div>
        </div>

        {/* Loading Spinner */}
        <div className="relative">
          <div className="w-12 h-12 border-4 border-gold/20 border-t-gold rounded-full animate-spin" />
        </div>

        {/* Loading Text */}
        <p className="text-sm text-muted-foreground animate-pulse">
          Loading...
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
